<template>
    <div class="page-banner">
        <div class="wrapper">
            <div class="d-block bg-dark line-h-0" :style="{width: windowClient.width + 'px', height: '486px'}" v-if="data.mediaType === 'VIDEO'">
                <video autoplay loop muted="true" :src="data.urls[0]" :style="{width: windowClient.width + 'px', height: '100%', objectFit: 'fill'}"/>
            </div>
            <swiper :options="swiperOptions" :style="{width: windowClient.width + 'px', height: '486px' }" v-if="data.mediaType === 'IMAGE'">
                <swiper-slide v-for="(item, index) in data.urls" :key="index">
                    <div class="d-flex justify-center" :style="{height: '486px', background: 'url('+ item +') top center no-repeat'}">
                        <img :src="item" style="max-width: 100%;" v-if="false"/>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="content">
                <h1 v-if="data.titleType === 'TXT'" style="font-size: 4em;">{{ data.title }}</h1>
                <h6 v-if="data.titleType === 'ICON'">
                    <img :src="data.icon" style="max-height: 96px;"/>
                </h6>
                <br/>
                <p class="size-28 c-white">{{ data.introduction }}</p>
            </div>
        </div>
        <div class="info" v-html="data.pageIntroduction"/>
    </div>
</template>

<script type="text/javascript">
    import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

    export default {
        components: {
            Swiper, SwiperSlide
        },
        data () {
            return {
                windowClient: {},
                swiperOptions: {
                    initialSlide: 0, // 默认选中
                    direction: 'horizontal', // 水平/垂直
                    autoplay: true,
                    delay: 2000, // 1.5秒切换一次
                    speed: 750, // 0.75秒切换速度
                    loop: false, // 循环
                    on: {
                        // 过度结束后
                        // transitionEnd() {
                        // console.log('this.activeIndex', this.activeIndex);
                        // },
                    }
                },
            }
        },
        props: ['data'],
        watch: {
            data: {
                handler(val){
                    console.log('banner data:---------->' + val);
                },
                deep: true, // 深度监听
            },
            windowClient(value){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if(!this.timer){
                    // 一旦监听到的windowClient值改变，就将其重新赋给data里的windowClient
                    this.windowClient = value;
                    this.timer = true;
                    let that = this;
                    setTimeout(function(){
                        console.log('windowClient---------->', that.windowClient);
                        that.timer = false;
                    },400);
                }
            },
        },
        created() {
            console.log('banner data:---------->');
            console.log(this.data);
            this.windowClient = {
                width: window.innerWidth,
                height: window.innerHeight,
            }
        },
        mounted() {
            this.__getWindowResize();
        },
        methods: {
            __getWindowResize(){
                window.onresize = () => {
                    return (() => {
                        this.windowClient = {
                            width: window.innerWidth,
                            height: window.innerHeight,
                        };
                    })()
                };
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/PageBanner.vue